<template>
	<div :id="modalName">
		<b-modal :id="modalName" title="New E-mail" scrollable hide-footer>
            <template v-slot:modal-title>
                <span>New E-mail: {{ email }}</span>
            </template>

            <b-form @submit.stop.prevent="createEmail">
                <b-form-row>
                    <b-col>
                        <b-form-row>
                            <b-col>
                                <b-form-group
                                    id="textarea-group-message"
                                    label="Message:"
                                    label-for="textarea-message"
                                    label-size="sm"
                                >
                                    <b-form-textarea
                                        id="textarea-message"
                                        v-model="create.message"
                                        placeholder=""
                                        rows="3"
                                        max-rows="6"
                                        size="sm"
                                    ></b-form-textarea>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                        <b-form-row class="file-select">
                            <b-col>
                                <b-form-group
                                    id="file-group-attach"
                                    label="Attachments:"
                                    label-for="file-attach"
                                    label-size="sm"
                                >
                                    <b-form-file
                                        id="file-attach"
                                        v-model="file"
                                        :state="Boolean(file)"
                                        @input="imageUploadHandler"
                                        placeholder="Drop file(s) here"
                                        drop-placeholder="Drop file(s) here..."
                                        multiple
                                        class="text-nowrap text-truncate"
                                        ref="form-file"
                                    ></b-form-file>
                                    <b-container  class="files-selected" fluid v-if="file">
                                        <b-row v-for="(attachment, index) in create.attachments" :key="index">
                                            <b-col>
                                                {{ attachment.filename }} <b-link @click="removeAttachment(index)"><i class="far fa-window-close fa-2x"></i></b-link>
                                                <hr>
                                            </b-col>
                                        </b-row>
                                    </b-container>
                                </b-form-group>
                            </b-col>
                        </b-form-row>
                    </b-col>
                </b-form-row>

                <b-form-row>
                    <b-col cols=2>
                        <b-button type="submit" variant="primary" class="btn-sm">
                            <span v-if="submitting">
                                <b-spinner small type="grow"></b-spinner>
                                Sending...
                            </span>
                            <span v-else>Send</span>
                        </b-button>
                    </b-col>
                </b-form-row>
            </b-form>
        </b-modal>
	</div>
</template>

<script>
	export default {
		props: [
            'email'
		],

		components: {

		},

		data() {
			return {
				modalName: 'modal-lists-customers-create-email',
				create: {
                    active: 0,
                    email: '',
                    message: '',
                    attachments: []
				},
                file: [],
                submitting: 0,
			}
		},

		methods: {
            imageUploadHandler() {
                const file = this.file
                if (file) {
                    file.forEach((row) => {
                        const reader = new FileReader()
                        reader.onload = e => this.create.attachments.push({ string: reader.result, filename: row.name })
                        reader.readAsDataURL(row);
                    })

                    let label = this.$refs['form-file'].$el.querySelectorAll(':scope > label')
                    label[0].innerHTML = 'Drop file(s) here'
                }
            },

            removeAttachment(index) {
                this.create.attachments.splice(index, 1)
            },

            createEmail() {
                this.submitting = 1
                let createData = this.create

                let url = 'api/lists/customers/createemail'
                axios.post(url, {
                    createData
                })
                .then((res) => {
                    this.submitting = 0

                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'E-mail Sent', 'E-mail sent successfully!')
                    } else {
                        this.showAlertBox('error', 'Error', 'Error sending-email!')
                    }
                }, () => {
                    this.has_error = true
                })
            }
		},

		computed: {

		},

		mounted() {
            this.create.email = this.email
		}
	}
</script>
<style lang="scss">
    #modal-lists-customers-create-email {
        .modal-content {
            max-height: 600px;
        }

        .file-select {
            font-size: 9pt;

            label {
                // color: #fff;
            }

            .files-selected {
                padding-top: 10px;

                .fa-window-close {
                    font-size: 12pt;
                    color: red;
                }
            }
        }
    }
</style>